import getPath from './getPath';

export type RouteInitialize = {
  name: string;
  path: string;
  isNotUrl?: boolean;
  hideParentUrl?: boolean;
  childRoutes: RouteInitialize[];
};

export type Route = {
  name: string;
  path: string;
  isNotUrl?: boolean;
  childRoutes: Route[];
  hideParentUrl?: boolean;
  getPath: (lang: string) => string;
};

const createRoute = (RouteInstance: RouteInitialize): Route => {
  return {
    ...RouteInstance,
    getPath: (lang) => getPath(RouteInstance, lang).replace('blog', '').replace(/\/+/g, '/'),
    childRoutes: RouteInstance.childRoutes.map((route) =>
      createRoute({ ...route, path: `${RouteInstance.path}/${route.path}` })
    ),
  };
};

export default createRoute;
